import { render, staticRenderFns } from "./trainingModuleFormBuilderFields.vue?vue&type=template&id=1fa85102&scoped=true"
import script from "./trainingModuleFormBuilderFields.vue?vue&type=script&lang=js"
export * from "./trainingModuleFormBuilderFields.vue?vue&type=script&lang=js"
import style0 from "./trainingModuleFormBuilderFields.vue?vue&type=style&index=0&id=1fa85102&prod&lang=css"
import style1 from "./trainingModuleFormBuilderFields.vue?vue&type=style&index=1&id=1fa85102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa85102",
  null
  
)

export default component.exports